export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 lg:p-16 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-background-50 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-accent-300 blur-3xl"></div>
          </div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-sm font-medium mb-6">
              <i className="ri-smartphone-line text-base"></i>
              移动端专属体验
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
              51吃瓜APP下载
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              随时随地打开51吃瓜APP，第一时间获取全网最新吃瓜视频与黑料入口。支持iOS和Android双平台，安装即用，吃瓜快人一步。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                iOS 版本下载
              </button>
              <button className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 版本下载
              </button>
            </div>
          </div>

          <div className="relative z-10 flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20app%20mockup%20for%20entertainment%20gossip%20news%20platform%2C%20clean%20modern%20UI%20design%2C%20trending%20topics%20feed%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20minimal%20layout%2C%20smartphone%20screen%20mockup%20in%20perspective&width=400&height=700&seq=app-mockup-51cg&orientation=portrait"
                alt="51吃瓜APP下载 - 移动端截图预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}